//
// scheduler-calendar-list-view.js
//
// Copyright (c) 2014 by Curalate, Inc.
//

/*jshint jquery: true */
/*global angular: false, console: false, moment: false,  _: false */

(function () {
    'use strict';

    var curalate = angular.module('curalate');

    var ALL_NETWORKS = ['Instagram', 'Pinterest'];

    curalate.directive('schedulerCalendarListView', ['SchedulerService', 'DateTimeService', 'EnvironmentService', 'SessionVarsService',
        function(SchedulerService, DateTimeService, EnvironmentService, SessionVarsService) {
            return {
                restrict: 'E',
                scope: {
                    initialDataPromise: '=',
                    boards: '=',
                    buffers: '=',
                    devices: '='
                },
                replace: true,
                templateUrl: EnvironmentService.getTemplateRootDirectory() + 'scheduler/scheduler-calendar-list-view.html',
                controller: ['$scope', '$rootScope', '$timeout',
                    function($scope, $rootScope, $timeout) {
                        var getPostGroups,
                            insertOrReplacePost,
                            PAGE_SIZE = 10,
                            dateCompareFormat = 'YYYY MM DD',
                            dateViewFormat = 'MMM Do, YYYY',
                            today = DateTimeService.userToday(),
                            tommorrow = DateTimeService.userTomorrow(),
                            aWeekAgo = DateTimeService.userToday().subtract(1, 'weeks'),
                            fetchPromise,
                            startDate,
                            endDate,
                            filterScheduled,
                            includeNotified,
                            updateSortTimes,
                            resetLoadingIndicator,
                            isRefreshingPosts = false,
                            refreshPosts,
                            resetContent;

                        startDate = aWeekAgo;
                        filterScheduled = true;
                        includeNotified = true;

                        $scope.timeline = {
                            allPosts: [],
                            allNetworks: ALL_NETWORKS,
                            filteredBuffer: null,
                            hasNoMoreItems: false,
                            isDisplayingCalendar: false,
                            initialContentLoaded: false,
                            isFirstLoad: true,
                            isLoadingPosts: true,
                            isLoadingNewContent: false,
                            isPinterestEnabled: true,
                            isInstagramEnabled: true,
                            itemType: 'upcoming',
                            itemTypeOnCalendarShow: 'upcoming',
                            enabledNetworks: ALL_NETWORKS,
                            postGroups: [],
                            timeZoneFullName: SessionVarsService.getTimeZoneFullName(),
                            isBrandPageV2Enabled: SessionVarsService.isFeatureEnabled('brand_page_v2'),
                            isVideoSchedulingEnabled: SessionVarsService.isFeatureEnabled('instagram_video_scheduling')
                        };

                        getPostGroups = function(postList, networkFilters) {
                            var postGroups = [],
                                sortedGroups;

                            var filteredList = _.filter(postList, function(post) {
                                var buffer;

                                if ($scope.buffers) {
                                    buffer = _($scope.buffers).findWhere({ id: post.bufferId });
                                    if (buffer) {
                                        return _(networkFilters).indexOf(buffer.network) !== -1;
                                    }
                                }

                                return false;
                            });

                            var groupsByDay = _.groupBy(filteredList, function(post) {
                                // Key by iso timestamp at start of date so we can recreate it.
                                return DateTimeService.userMoment(post.scheduleDateTime).startOf('day').format();
                            });
                            _.each(_.pairs(groupsByDay), function(pair) {
                                var date = DateTimeService.userMoment(pair[0]),
                                    posts = pair[1],
                                    compareDate = date.format(dateCompareFormat),
                                    formattedDate;
                                if (date.isSame(DateTimeService.userToday())) {
                                    formattedDate = 'Today, ' + date.format(dateViewFormat);
                                } else if (date.isSame(DateTimeService.userTomorrow())) {
                                    formattedDate = 'Tomorrow, ' + date.format(dateViewFormat);
                                } else {
                                    formattedDate = date.format('dddd, ' + dateViewFormat);
                                }
                                postGroups.push({
                                    name: formattedDate,
                                    date: compareDate,
                                    posts: posts
                                });
                            });

                            sortedGroups = _.sortBy(postGroups, function(group) { return group.date; });
                            if ($scope.timeline.itemType === 'posted') {
                                sortedGroups = sortedGroups.reverse();
                            }
                            return sortedGroups;
                        };

                        insertOrReplacePost = function(post) {
                            var idx, postCount;

                            postCount = $scope.timeline.allPosts.length;
                            for (idx = 0; idx < postCount; idx++) {
                                if ($scope.timeline.allPosts[idx].id === post.id) {
                                    $scope.timeline.allPosts.splice(idx, 1);
                                    break;
                                }
                            }

                            $scope.timeline.allPosts.push(post);
                            updateSortTimes();
                        };

                        resetLoadingIndicator = function() {
                            if (fetchPromise) {
                                fetchPromise.abort();
                                fetchPromise = undefined;
                            }

                            $scope.timeline.hasNoMoreItems = false;
                            $scope.timeline.isFirstLoad = true;
                            $scope.timeline.isLoadingPosts = true;
                        };

                        // We duplicate the 'scheduleDateTime' field so that items don't re-order themselves
                        // while being edited.  Sort times are only updated when more items are fetched, added, or
                        // when a post has finished being edited.
                        updateSortTimes = function() {
                            _.each($scope.timeline.allPosts, function(p) {
                                p.sortTime = DateTimeService.formatUserMoment(p.scheduleDateTime);
                            });
                        };

                        $scope.timeline.reloadWithItemType = function() {
                            fetchPromise = undefined;
                            if ($scope.timeline.itemType === 'upcoming') {
                                filterScheduled = true;
                                includeNotified = true;
                                resetLoadingIndicator();
                                startDate = aWeekAgo;
                                endDate = undefined;

                                $scope.timeline.allPosts = [];
                                $scope.timeline.postGroups = getPostGroups($scope.timeline.allPosts, $scope.timeline.enabledNetworks);
                                $scope.timeline.loadMorePosts();
                            } else {
                                filterScheduled = false;
                                includeNotified = false;
                                resetLoadingIndicator();
                                startDate = undefined;
                                endDate = tommorrow;

                                $scope.timeline.allPosts = [];
                                $scope.timeline.postGroups = getPostGroups($scope.timeline.allPosts, $scope.timeline.enabledNetworks);
                                $scope.timeline.loadMorePosts();
                            }
                        };

                        $scope.timeline.changeItemType = function(value) {
                            $scope.timeline.itemType = value;
                            $scope.timeline.reloadWithItemType();
                        };

                        $scope.timeline.filterBuffer = function(buffer) {
                            if ($scope.timeline.filteredBuffer && buffer.id === 0) {
                                $scope.timeline.filteredBuffer = null;
                            } else {
                                $scope.timeline.filteredBuffer = buffer;
                            }

                            resetLoadingIndicator();
                            $scope.timeline.allPosts = [];
                            $scope.timeline.postGroups = [];
                            $scope.timeline.loadMorePosts();
                            $rootScope.$broadcast('toggleBuffer', $scope.timeline.filteredBuffer);
                        };

                        $scope.timeline.isBufferFiltered = function(buffer) {
                            return $scope.timeline.filteredBuffer && $scope.timeline.filteredBuffer.id === buffer.id;
                        };

                        // TODO: Allow exporting to CSV for combinations of multiple networks
                        $scope.timeline.canExportToCsv = function() {
                            return $scope.timeline.enabledNetworks.length === 1;
                        };

                        $scope.timeline.exportToCsvLink = function() {
                            if ($scope.timeline.enabledNetworks.length === 1) {
                                return SchedulerService.getAllBufferItemsExportUrl({
                                    socialNetworks: $scope.timeline.enabledNetworks,
                                    startDate: startDate,
                                    endDate: endDate,
                                    itemType: $scope.timeline.itemType,
                                    scheduled: filterScheduled,
                                    includeNotified: includeNotified,
                                    bufferIds: $scope.timeline.filteredBuffer ? [$scope.timeline.filteredBuffer.id] : []
                                });
                            } else {
                                return '#';
                            }
                        };

                        $scope.timeline.networkChanged = function(network) {
                            // do nothing for subsequent clicks on the same network
                            if (angular.equals([network], $scope.timeline.enabledNetworks)) {
                                return;
                            }

                            if (network === 'All') {
                                $scope.timeline.enabledNetworks = ALL_NETWORKS;
                            } else {
                                $scope.timeline.enabledNetworks = [network];
                            }

                            $scope.timeline.allPosts = [];
                            $scope.timeline.postGroups = getPostGroups($scope.timeline.allPosts, $scope.timeline.enabledNetworks);
                            $rootScope.$emit('toggleNetwork', network);
                            refreshPosts();
                        };

                        $scope.timeline.navToday = function() {
                            $rootScope.$emit('navToday');
                        };

                        $scope.timeline.toggleCalendarView = function() {
                            $scope.timeline.isDisplayingCalendar = !$scope.timeline.isDisplayingCalendar;

                            resetLoadingIndicator();

                            if (!$scope.timeline.isDisplayingCalendar) {
                                $scope.timeline.itemType = $scope.timeline.itemTypeOnCalendarShow;
                                $scope.timeline.reloadWithItemType();
                            } else {
                                $scope.timeline.itemTypeOnCalendarShow = $scope.timeline.itemType;
                                $scope.timeline.itemType = 'upcoming';
                            }
                            $rootScope.$emit('toggleCalendar');
                        };

                        $scope.timeline.postRemoved = function(id) {
                            // Remove post from the master list
                            $scope.timeline.allPosts = _.reject($scope.timeline.allPosts, function(post) { return post.id === id; });

                            // Remove from the generated views
                            _.each($scope.timeline.postGroups, function(group) {
                                group.posts = _.reject(group.posts, function (post) { return post.id === id; });
                            });

                            $scope.timeline.postGroups = _.reject($scope.timeline.postGroups, function (group) { return group.posts.length === 0; });

                            $rootScope.$emit('scheduler:BufferItemsModified');

                            $rootScope.$emit('postDeleted');
                        };

                        $scope.timeline.loadMorePosts = _.throttle(function() {
                            var count;
                            if ($scope.timeline.initialContentLoaded && ((!$scope.timeline.isLoadingPosts && !$scope.timeline.hasNoMoreItems) || $scope.timeline.isFirstLoad)) {
                                count = isRefreshingPosts ? 0 : $scope.timeline.allPosts.length;

                                $scope.timeline.isFirstLoad = false;
                                $scope.timeline.isLoadingPosts = true;
                                $scope.timeline.isLoadingNewContent = count === 0;

                                fetchPromise = SchedulerService.getAllBufferItemsAsync({
                                    socialNetworks: $scope.timeline.enabledNetworks,
                                    startDate: startDate,
                                    endDate: endDate,
                                    offset: count,
                                    limit: PAGE_SIZE,
                                    itemType: $scope.timeline.itemType,
                                    scheduled: filterScheduled,
                                    includeNotified: includeNotified,
                                    bufferIds: $scope.timeline.filteredBuffer ? [$scope.timeline.filteredBuffer.id] : []
                                });

                                fetchPromise.then(function(response) {
                                    if (typeof response !== 'undefined') {
                                        if (response.items.length < PAGE_SIZE) {
                                            $scope.timeline.hasNoMoreItems = true;
                                        }

                                        if (isRefreshingPosts) {
                                            $scope.timeline.allPosts = [];
                                            $scope.timeline.postGroups = [];
                                        }

                                        _.each(response.items, function(post) {
                                            insertOrReplacePost(post);
                                        });

                                        updateSortTimes();
                                        $scope.timeline.postGroups = getPostGroups($scope.timeline.allPosts, $scope.timeline.enabledNetworks);
                                        $scope.timeline.isLoadingNewContent = false;

                                        if (!isRefreshingPosts) {
                                            $scope.$broadcast('scroll.infiniteScrollComplete');
                                        }
                                    }
                                }).finally(function() {
                                    $scope.timeline.isLoadingPosts = false;
                                    fetchPromise = undefined;
                                    isRefreshingPosts = false;
                                });
                            }

                        }, 500, true);

                        $scope.timeline.selectDateRange = function(start, end) {
                            if (!start || !end) {
                                startDate = today;
                                endDate = undefined;
                                filterScheduled = true;
                                includeNotified = true;
                            } else {
                                startDate = start;
                                endDate = end;
                                filterScheduled = false;
                                includeNotified = true;
                            }

                            resetLoadingIndicator();

                            $scope.timeline.postGroups = [];
                            $scope.timeline.allPosts = [];

                            // Fetch the timeline on the next tick to avoid posts with the same id not being initialized.
                            $timeout(function() {
                                $scope.timeline.loadMorePosts();
                            });
                        };

                        $scope.timeline.launchEditModal = function() {
                            $rootScope.$emit('scheduler:ModifyBuffer', $scope.timeline.filteredBuffer);
                        };

                        $scope.timeline.launchReorderModal = function() {
                            if ($scope.timeline.filteredBuffer && $scope.timeline.filteredBuffer.autoScheduledCount > 1) {
                                $rootScope.$emit('scheduler:ReorderPosts', $scope.timeline.filteredBuffer);
                            }
                        };

                        $scope.timeline.getReorderTooltip = function() {
                            if ($scope.timeline.filteredBuffer) {
                                switch ($scope.timeline.filteredBuffer.autoScheduledCount) {
                                    case 0:
                                        return 'This feature is only available for Auto-scheduled posts.';
                                    case 1:
                                        return 'You only have 1 Auto-scheduled post. Add more images and then try again.';
                                }
                            }
                            return false;
                        };

                        $rootScope.$on('postScheduled', function(event, post) {
                            if (post.status === 'notified') {
                                $rootScope.$emit('mobile:PostNow', post);
                            }

                            insertOrReplacePost(post);
                            $scope.timeline.postGroups = getPostGroups($scope.timeline.allPosts, $scope.timeline.enabledNetworks);
                        });

                        $rootScope.$on('postUpdated', function($event, post) {
                            insertOrReplacePost(post);
                            $scope.timeline.postGroups = getPostGroups($scope.timeline.allPosts, $scope.timeline.enabledNetworks);
                        });

                        $rootScope.$on('scheduler:PostsReordered', function() {
                            $scope.timeline.reloadWithItemType();
                        });

                        $scope.$on('scmv:selection-changed', function() {
                            resetLoadingIndicator();
                        });

                        $scope.$on('sclv:RefreshPosts', function() {
                            refreshPosts();
                        });

                        $scope.$on('scheduler:PostRemoved', function($event, postId) {
                            $scope.timeline.postRemoved(postId);
                        });

                        $scope.$on('sclv:ResetContent', function() {
                            $scope.initialDataPromise.then(function() {
                                // Wait for buffers to be available before pulling initial content,
                                // so filtering works properly.
                                resetContent();
                            });
                        });

                        $scope.$watch('buffers', function(data) {
                            // If buffers changes and we have a selected buffer, we want to update that buffer with its current state
                            if ($scope.timeline.filteredBuffer) {
                                var targetBuffer = _.findWhere(data, {id: $scope.timeline.filteredBuffer.id});
                                $scope.timeline.filteredBuffer = targetBuffer;
                            }
                        });

                        // This reloads the existing content (i.e. the list of the buffer items) without resetting filters, buffers, and devices.
                        refreshPosts = function() {
                            isRefreshingPosts = true;
                            resetLoadingIndicator();
                            $scope.timeline.loadMorePosts();

                            if (fetchPromise) {
                                fetchPromise.finally(function() {
                                    $scope.$emit('scroll.refreshComplete');
                                });
                            } else {
                                $scope.$emit('scroll.refreshComplete');
                            }
                        };

                        resetContent = function() {
                            $scope.timeline.initialContentLoaded = true;
                            $scope.timeline.allPosts = [];
                            $scope.timeline.postGroups = [];

                            resetLoadingIndicator();
                            $scope.timeline.loadMorePosts();
                        };

                        $scope.initialDataPromise.then(function() {
                            // Wait for buffers to be available before pulling initial content,
                            // so filtering works properly.
                            resetContent();
                        });
                    }
                ]
            };
        }
    ]);
})();
